import { Component } from '@angular/core';
import { AuthenticationService } from './../services/authentication.service';
import { Observable } from 'rxjs';
import { AngularDelegate, ModalController, LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-timetableSelect',
  templateUrl: 'timetableSelect.page.html',
  styleUrls: ['timetableSelect.page.scss']
})
export class TimetableSelectPage {

  timetable_id: string;
  timetable_group_id: string;
  entity: string;
  property: string;

  timetables: any=[];
  groups: any=[];
  objects: any=[];

  constructor(private authService: AuthenticationService, private modalController: ModalController, private loadingController:LoadingController) {}

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }
  
  async changeTimetable() {


    const loading =  await this.loadingController.create({
      message: "Stundenplan wechseln...",
    });

    await loading.present();

    this.authService.getFromEndpoint('timetables/'+this.timetable_id+'/groups').subscribe(groups => {
      this.groups = groups;
      this.timetable_group_id = groups[0].id;

      loading.dismiss();
   })

  }

  ionViewWillEnter() {

      this.entity = 'studygroup';
      
      
      this.getTimetables().then(()=> {
        this.getObjects('studygroup');
      });
  }

  changeType(type) {
    this.getObjects(type.target.value);
  }

  async getTimetables() {

    const loading =  await this.loadingController.create({
      message: "Stundenpläne laden...",
    });

    await loading.present();
    

    this.authService.getFromEndpoint('timetable/choice').subscribe(data => {
      this.timetables = data;
      this.timetable_id = data[0].id;
      loading.dismiss();

    })
  }

  async getObjects(type) {

    const loading =  await this.loadingController.create({
      message: "Filteroptionen laden...",
    });

    await loading.present();
    

    this.authService.getFromEndpoint('timetable/entitys/'+type+'s').subscribe(data => {
      this.objects = data;
      this.property = data[0].name;

      loading.dismiss();
   })
  }

  submit() {
    var options = {
      "timetable_id": this.timetable_id,
      "timetable_group_id": this.timetable_group_id,
      "entity": this.entity,
      "property": this.property,
    };
    this.modalController.dismiss(options);
  }

}
